var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.657,
    height: 32,
    viewBox: "0 0 40.657 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(0 -44.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73704",
    "data-name": "Group 73704",
    transform: "translate(0 44.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73703",
    "data-name": "Group 73703",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90696",
    "data-name": "Path 90696",
    d: "M39.3,49.786A4.371,4.371,0,0,0,36.1,48.433H29.681v-.077a3.47,3.47,0,0,0-1.043-2.512A3.536,3.536,0,0,0,26.126,44.8H14.531a3.563,3.563,0,0,0-3.594,3.556v.077H4.56a4.371,4.371,0,0,0-3.208,1.353A4.6,4.6,0,0,0,0,52.993V72.24a4.371,4.371,0,0,0,1.353,3.208A4.6,4.6,0,0,0,4.56,76.8H36.1A4.371,4.371,0,0,0,39.3,75.447a4.6,4.6,0,0,0,1.353-3.208V52.993A4.371,4.371,0,0,0,39.3,49.786ZM38.647,72.24h-.039A2.507,2.507,0,0,1,36.1,74.752H4.56A2.507,2.507,0,0,1,2.048,72.24V52.993A2.507,2.507,0,0,1,4.56,50.481h7.459a1.039,1.039,0,0,0,1.043-1.043V48.317A1.455,1.455,0,0,1,14.57,46.81H26.126a1.455,1.455,0,0,1,1.507,1.507v1.121a1.039,1.039,0,0,0,1.043,1.043h7.459a2.507,2.507,0,0,1,2.512,2.512Z",
    transform: "translate(0 -44.8)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90697",
    "data-name": "Path 90697",
    d: "M121.507,130.8a9.5,9.5,0,1,0,6.725,2.783A9.524,9.524,0,0,0,121.507,130.8Zm5.256,14.8a7.464,7.464,0,0,1-10.512,0,7.388,7.388,0,0,1-2.164-5.256,7.553,7.553,0,0,1,2.164-5.256,7.388,7.388,0,0,1,5.256-2.164,7.553,7.553,0,0,1,5.256,2.164,7.388,7.388,0,0,1,2.164,5.256A7.232,7.232,0,0,1,126.763,145.6Z",
    transform: "translate(-101.179 -122.491)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1938",
    "data-name": "Ellipse 1938",
    cx: 1.894,
    cy: 1.894,
    r: 1.894,
    transform: "translate(32.193 8.271)",
    fill: "#ccc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b4f5deb15c1423262c624f28ad8693ea.svg";
export { ForwardRef as ReactComponent };